<app-top-navbar></app-top-navbar>

<div class="content">
  <div class="contact-card">
    <h2 class="mb-4" style="text-align:center">Contact Information</h2>

    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" novalidate>
      <!-- Name & Position -->
      <div class="row mb-3">
        <div class="col-md-6">
          <label class="form-label"
            >Name <span class="text-danger">*</span></label
            >
            <input
              type="text"
              class="form-control"
              formControlName="name"
              placeholder="John Doe"
              />
              @if (
                contactForm.get('name')?.invalid &&
                contactForm.get('name')?.touched
                ) {
                <div
                  class="text-danger small"
                  >
                  Name is required
                </div>
              }
            </div>

            <div class="col-md-6">
              <label class="form-label"
                >Position <span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  formControlName="position"
                  placeholder="Marketing Manager"
                  />
                  @if (
                    contactForm.get('position')?.invalid &&
                    contactForm.get('position')?.touched
                    ) {
                    <div
                      class="text-danger small"
                      >
                      Position is required
                    </div>
                  }
                </div>
              </div>

              <!-- Company -->
              <div class="mb-3">
                <label class="form-label"
                  >Company Name <span class="text-danger">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    formControlName="company"
                    placeholder="Acme Corp"
                    />
                    @if (
                      contactForm.get('company')?.invalid &&
                      contactForm.get('company')?.touched
                      ) {
                      <div
                        class="text-danger small"
                        >
                        Company is required
                      </div>
                    }
                  </div>

                  <!-- Email & Phone -->
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label class="form-label"
                        >Email <span class="text-danger">*</span></label
                        >
                        <input
                          type="email"
                          class="form-control"
                          formControlName="email"
                          placeholder="john@example.com"
                          />
                          @if (
                            contactForm.get('email')?.hasError('required') &&
                            contactForm.get('email')?.touched
                            ) {
                            <div
                              class="text-danger small"
                              >
                              Email is required
                            </div>
                          }
                          @if (
                            contactForm.get('email')?.hasError('email') &&
                            !contactForm.get('email')?.hasError('required')
                            ) {
                            <div
                              class="text-danger small"
                              >
                              Please enter a valid email
                            </div>
                          }
                        </div>

                        <div class="col-md-6">
                          <label class="form-label"
                            >Phone <span class="text-danger">*</span></label
                            >
                            <input
                              type="tel"
                              class="form-control"
                              formControlName="phone"
                              placeholder="+1 (555) 123-4567"
                              />
                              @if (
                                contactForm.get('phone')?.invalid &&
                                contactForm.get('phone')?.touched
                                ) {
                                <div
                                  class="text-danger small"
                                  >
                                  Valid phone number is required
                                </div>
                              }
                            </div>
                          </div>

                          <!-- Preferred Contact Method -->
                          <div class="row mb-3">
                            <div class="col-md-6">
                              <label class="form-label d-block">
                                Preferred Contact Method <span class="text-danger">*</span>
                              </label>
                              <div class="d-flex align-items-center">
                                <div class="form-check me-3" style="margin-top:10px;">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="emailMethod"
                                    value="email"
                                    formControlName="contactMethod"
                                    />
                                    <label class="form-check-label" for="emailMethod">Email</label>
                                  </div>

                                  <div class="form-check" style="margin-top:10px;">
                                    <input
                                      class="form-check-input"
                                      type="radio"
                                      id="phoneMethod"
                                      value="phone"
                                      formControlName="contactMethod"
                                      />
                                      <label class="form-check-label" for="phoneMethod">Phone</label>
                                    </div>
                                  </div>
                                  @if (
                                    contactForm.get('contactMethod')?.invalid &&
                                    contactForm.get('contactMethod')?.touched
                                    ) {
                                    <div
                                      class="text-danger small mt-1"
                                      >
                                      Please choose a contact method
                                    </div>
                                  }
                                </div>

                                <div class="col-md-6">
                                  <label class="form-label">
                                    Reason for Contacting <span class="text-danger">*</span>
                                  </label>
                                  <ng-select
                                    [items]="reasons"
                                    bindLabel="name"
                                    bindValue="id"
                                    placeholder="Select a reason"
                                    formControlName="reason"
                                    [clearable]="false"
                                    [searchable]="false"
                                    >
                                  </ng-select>
                                  @if (
                                    contactForm.get('reason')?.invalid &&
                                    contactForm.get('reason')?.touched
                                    ) {
                                    <div
                                      class="text-danger small mt-1"
                                      >
                                      Please select a reason
                                    </div>
                                  }
                                </div>
                              </div>

                              <!-- Message -->
                              <div class="mb-4">
                                <label class="form-label"
                                  >Message <span class="text-danger">*</span></label
                                  >
                                  <textarea
                                    class="form-control"
                                    rows="4"
                                    formControlName="message"
                                    placeholder="Tell us how we can help you..."
                                  ></textarea>
                                  @if (
                                    contactForm.get('message')?.invalid &&
                                    contactForm.get('message')?.touched
                                    ) {
                                    <div
                                      class="text-danger small"
                                      >
                                      Message is required
                                    </div>
                                  }
                                </div>

                                <!-- Submit Button -->
                                <div class="text-center">
                                  <button
                                    type="submit"
                                    class="btn btn-primary btn-sm px-5"
                                    [disabled]="contactForm.invalid"
                                    >
                                    Send Message
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>

                          <app-bottom-footer></app-bottom-footer>

